import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=d7464bfc&scoped=true"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateForm.vue?vue&type=style&index=0&id=d7464bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7464bfc",
  null
  
)

export default component.exports